import React from 'react';
import setImageSize from 'constants/utilityFunctions';
import { maxWidth, primaryFont, retina, wMedium } from 'constants/utilsStyles';
import styled from 'styled-components';
import { IContactItem } from 'modules/Audience/interface';
import BlankProfilePhoto from "../../../assets/img/blank_profile_photo.png";

const ContactWidgetWrapper = styled.div<{ diameter?: string, diameterL?: string, ringPadding?: string, personalityColor?: string, margin?: string }>`
position: relative;
margin: ${(props) => props.margin};
.image-wrapper {
  width: ${(props) => props.diameterL};
  min-width: ${(props) => props.diameterL};
  height: ${(props) => props.diameterL};
  @media all and (max-width: ${maxWidth}), ${retina} {
    width: ${(props) => props.diameter};
    min-width: ${(props) => props.diameter};
    height: ${(props) => props.diameter};
  }
  border-radius: 50%;
  background: ${(props) => props.personalityColor};
  padding: ${(props) => props.ringPadding};
  .contact-image {
    height: 100%;
    width: 100%;
    border-radius: 50%;
    margin-bottom: 10px;
  }
}
.personality-pill {
  position: absolute;
  bottom: -5px;
  left: 50%;
  transform: translateX(-50%);
  font-family: ${primaryFont};
  font-weight: ${wMedium};
  font-size: 18px;
  line-height: 22px;
  padding: 6px 20px 5px;
  border-radius: 23px;
  background-color:  ${(props) => props.personalityColor};
  color: #fff;

  @media all and (max-width: ${maxWidth}), ${retina} {
    font-size: 14px;
    line-height: 22px;
    padding: 1px 12px 2px;
  }
}
`;
type Props = {
  diameter?: string,
  diameterL?: string,
  diameterSm?: string,
  margin?: string,
  marginSm?: string,
  ringPadding?: string,
  hidePersonality?: boolean,
  personalityColor?: string,
  contact: IContactItem,
} & typeof defaultProps;

const defaultProps = {
  diameter: '135px',
  diameterL: '155px',
  diameterSm: '90px',
  margin: '0px 0px 10px 0px',
  marginSm: '0px',
  ringPadding: '4px',
  hidePersonality: true,
  personalityColor: 'red',
};
const ContactWidget = function ContactWidget(props: Props) {
  const { diameter, diameterL, ringPadding, personalityColor, margin, hidePersonality, contact: { thumbnail, color, personality } } = props;
  return (
    <ContactWidgetWrapper
      className='contact-widget-wrapper'
      diameter={diameter}
      diameterL={diameterL}
      ringPadding={ringPadding}
      personalityColor={color}
      margin={margin}
    >
      <div className='image-wrapper'>
        <img src={thumbnail ? setImageSize(thumbnail, 133, 133, 0) : BlankProfilePhoto} style={{ ...(!thumbnail && { backgroundColor: 'white' }) }} alt="contact-img" className='contact-image' />
      </div>
      {!hidePersonality ? (
        <span className='personality-pill'>{personality}</span>
      ) : null}
    </ContactWidgetWrapper>
  );
};
ContactWidget.defaultProps = defaultProps;
export default ContactWidget;